import { useCallback, useEffect } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";
import { ACITVE_CONTENT_PADDING_BOTTOM } from "CrossFeatureComponents/MemberToolbar/styleConstants";

import FnrDismissibleError from "UI/FnrDismissibleError";

import ActiveContentWrapper from "../ActiveContentWrapper";

import BackButton from "./BackButton";
import Header from "./Header";
import Input from "./Input";
import PrayerRequestVeriage from "./PrayerRequestVerbiage";
import SendButton from "./SendButton";
import { useOnSubmit } from "./stateHooks";

const ContactForm = () => {
  const { activeContentKey } = useMemberToolbarStore();
  const { prayerRequest } = useMemberToobarContext();
  const { onSubmit, isLoading, errorMessage, setShowError, showError } =
    useOnSubmit();

  const clearError = useCallback(() => {
    setShowError(false);
  }, [setShowError]);

  useEffect(() => {
    clearError();
  }, [activeContentKey, clearError]);

  return (
    <ActiveContentWrapper>
      <WrapperForm
        data-cy="MemberToolbar_ContactFormContainer"
        onSubmit={onSubmit}
      >
        <Top>
          <BackButton />
          <Header />
        </Top>
        {prayerRequest && <PrayerRequestVeriage />}
        <Input onChange={clearError} />
        <FnrDismissibleError
          errorMessage={errorMessage}
          show={showError}
          onDismiss={clearError}
          translateY={-102}
          translateX={48}
          xOnRight
        />
        <SendButton isLoading={isLoading} />
      </WrapperForm>
    </ActiveContentWrapper>
  );
};

const Top = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: -10px;
  padding-bottom: 16px;
`;

const WrapperForm = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-bottom: ${ACITVE_CONTENT_PADDING_BOTTOM}px;
`;

export default ContactForm;
